export default `
mutation removeAddressFromMyProfile($address_id:ID!) { 
    removeAddressFromMyProfile(address_id:$address_id){ 
       removed
       address_id
        }
    }
`;